/* eslint-disable import/order */
import { useMemo } from 'react';
import { IconButton, Typography } from '@lux/ds';
import { useLocation } from 'react-router-dom';
import { Logout } from '@mui/icons-material';
import { HeaderWrapper, ActionsWrapper } from './Header.styles';
import StagingBanner from '../../components/staging-banner/StagingBanner';
import productsConfig from '../../configs/productsConfig';
import hostnames from '../../hostnames';
import EProduct from '../../products';

const InnerHeader: React.FC = () => {
  const location = useLocation();
  const { isDev, selectedProduct } = useMemo(() => {
    const host = window.location.hostname;

    switch (host) {
      case hostnames.cmProd:
        return { isDev: false, selectedProduct: EProduct.channels };
      case hostnames.cmStaging:
        return { isDev: true, selectedProduct: EProduct.channels };
      case hostnames.cmSandbox:
        return {
          isDev: true,
          selectedProduct: EProduct.channels,
        };
      case hostnames.cmAllocationProd:
        return { isDev: false, selectedProduct: EProduct.channels };
      case hostnames.cmAllocationStaging:
        return { isDev: true, selectedProduct: EProduct.channels };
      case hostnames.cmAllocationSandbox:
        return {
          isDev: true,
          selectedProduct: EProduct.channels,
        };
      case hostnames.ibProd:
        return { isDev: false, selectedProduct: EProduct.inbound };
      case hostnames.ibSandbox:
        return { isDev: true, selectedProduct: EProduct.inbound };
      case hostnames.stProd:
      case hostnames.bbProd:
        return { isDev: false, selectedProduct: EProduct.buyback };
      case hostnames.stSandbox:
      case hostnames.bbSandbox:
        return { isDev: true, selectedProduct: EProduct.buyback };
      case hostnames.ivProd:
        return { isDev: false, selectedProduct: EProduct.inventory };
      case hostnames.ivSandbox:
        return { isDev: true, selectedProduct: EProduct.inventory };
      case hostnames.prProd:
        return { isDev: false, selectedProduct: EProduct.inventory };
      case hostnames.prSandbox:
        return { isDev: true, selectedProduct: EProduct.inventory };
      case hostnames.opProd:
        return { isDev: false, selectedProduct: EProduct.operations };
      case hostnames.opSandbox:
        return { isDev: true, selectedProduct: EProduct.operations };
      default:
        return { isDev: true };
    }
  }, []);

  const handleLogout = () => {
    document.dispatchEvent(new Event('LUX_CORE_LOGOUT_TRIGGER'));
  };

  const pageTitle = useMemo(() => {
    const modules = productsConfig
      .filter(({ product }) => product === selectedProduct)
      .flatMap(({ modules }) => modules);

    const { pageTitle } = modules.find(({ path }) => location.pathname.includes(path)) || {};

    return pageTitle || (selectedProduct === EProduct.inbound ? undefined : modules[0]?.pageTitle);
  }, [productsConfig, selectedProduct, location]);

  return (
    <HeaderWrapper>
      {pageTitle && (
        <Typography variant="h5" weight="bold" sx={{ flex: 1 }}>
          {pageTitle}
        </Typography>
      )}
      <ActionsWrapper>
        {isDev && <StagingBanner />}
        <Typography variant="bodyTextSmall" color="primary.shade.40">
          {selectedProduct || 'localhost'}
        </Typography>
        <IconButton onClick={handleLogout}>
          <Logout />
        </IconButton>
      </ActionsWrapper>
    </HeaderWrapper>
  );
};

export default InnerHeader;
